import { Box, Stack, Typography, Collapse, Divider, Chip } from '@mui/material'
import React, { useState } from 'react'
import { eTypePosition } from '../../../../enums/eTypePosition'
import { Stock } from '../../../../interfaces'
import { formatExpirationDate } from '../../../../utils/dateHelper'
import { skuResultsStyles as s } from '../Styles/StockBySkuResults.styles'

export const LocationCard: React.FC<{ item: Stock }> = ({ item }) => {
  const [expanded, setExpanded] = useState(false)
  const hasBatches = item.details?.length > 0

  return (
    <Box sx={s.locationCard}>
      <Stack
        direction='row'
        alignItems='flex-start'
        justifyContent='space-between'
        sx={{ p: 1 }}
      >
        <Stack spacing={0.75}>
          <Stack direction='row' alignItems='center' spacing={1}>
            <Typography sx={s.positionCode}>{item.positionCode}</Typography>
          </Stack>
          {item.details.length > 0 && (
            <Chip
              label='FEFO disponible'
              size='small'
              sx={s.fefoChip}
              variant='outlined'
              icon={<Box sx={s.fefoChipDot} />}
            />
          )}
          <Chip
            label={
              item.typePositionId === eTypePosition.Venta
                ? 'Ubicación de venta'
                : item.typePositionDescription
            }
            size='small'
            variant='outlined'
            sx={s.typePositionChip}
          />
        </Stack>
        <Stack alignItems='flex-end'>
          <Typography sx={s.quantityLabel}>Cantidad</Typography>
          <Typography sx={s.quantityValue}>{item.quantity}</Typography>
        </Stack>
      </Stack>

      {hasBatches && (
        <>
          <Box onClick={() => setExpanded((p) => !p)} sx={s.fefoToggle}>
            <Typography sx={s.fefoToggleLabel}>
              {expanded ? 'Ocultar detalle FEFO' : 'Mostrar detalle FEFO'}
            </Typography>
          </Box>

          <Collapse in={expanded}>
            <Box sx={{ px: 1.5, pb: 1.5 }}>
              <Stack
                direction='row'
                justifyContent='space-between'
                sx={s.batchHeader}
              >
                {['Lote', 'Vencimiento', 'Cantidad'].map((h) => (
                  <Typography key={h} sx={s.batchHeaderText}>
                    {h}
                  </Typography>
                ))}
              </Stack>
              <Divider />
              <Stack spacing={0.5} mt={0.5}>
                {item.details.map((d) => {
                  const expired = formatExpirationDate(d.expires, 'dd-MM-yyyy')
                  return (
                    <Stack
                      key={d.batchNumber}
                      direction='row'
                      justifyContent='space-between'
                      alignItems='center'
                      sx={s.batchRow(!!expired)}
                    >
                      <Typography sx={s.batchText(!!expired)}>
                        {d.batchNumber}
                      </Typography>
                      <Typography sx={s.batchText(!!expired, 'center')}>
                        {formatExpirationDate(d.expires, 'dd-MM-yyyy')}
                      </Typography>
                      <Typography sx={s.batchText(!!expired, 'right')}>
                        {d.qty}
                      </Typography>
                    </Stack>
                  )
                })}
              </Stack>
            </Box>
          </Collapse>
        </>
      )}
    </Box>
  )
}
